import { render, staticRenderFns } from "./NaverCallback.vue?vue&type=template&id=445cc488&scoped=true"
import script from "./NaverCallback.vue?vue&type=script&lang=js"
export * from "./NaverCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445cc488",
  null
  
)

export default component.exports